import fancybox from '@fancyapps/fancybox/dist/jquery.fancybox.min';

export default function initializeFancybox() {
    $.fancybox.defaults.i18n.pl = {
        CLOSE       : 'Zamknij',
        NEXT        : 'Dalej',
        PREV        : 'Wstecz',
        ERROR       : 'Wystąpił błąd podczas ładowania zawartości.<br>Spróbuj ponownie.',
        PLAY_START  : 'Rozpocznij pokaz slajdów',
        PLAY_STOP   : 'Zatrzymaj pokaz slajdów',
        FULL_SCREEN : 'Pełny ekran',
        THUMBS      : 'Miniatury',
        DOWNLOAD    : 'Pobierz',
        SHARE       : 'Udostępnij',
        ZOOM        : 'Przybliż'
    };

    $.fancybox.defaults.i18n.ua = {
        CLOSE       : 'Закрий це',
        NEXT        : 'Далі',
        PREV        : 'Назад',
        ERROR       : 'Під час завантаження вмісту сталася помилка. <br> Спробуйте ще раз.',
        PLAY_START  : 'Почніть показ слайдів',
        PLAY_STOP   : 'Зупинити показ слайдів',
        FULL_SCREEN : 'Повноекранний',
        THUMBS      : 'Ескізи',
        DOWNLOAD    : 'Завантажити',
        SHARE       : 'Поділіться',
        ZOOM        : 'прибл'
    };

    $('[data-fancybox]').fancybox({
        buttons: [
            "zoom",
            "close"
        ],
        lang: document.body.dataset.lang
    });
}